<template>
  <div class="asc-zoom-chip">
    <v-btn
      depressed
      :ripple="false"
      class="v-btn"
      :class="{ active: isActive }"
    >
      {{ text }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'AscZoomChip',

  props: {
    text: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.asc-zoom-chip {
  .v-btn__content {
    color: $primary-black;
    // override the default button styling to keep the text labels
    // as they are passed in instead of all uppercase
    text-transform: initial;
  }

  .theme--light.v-btn:not(.v-btn--icon):not(.v-btn--text) {
    align-items: center;
    background-color: $primary-white;
    cursor: default;
    height: 22px;
    line-height: 18px;
    min-width: 22px;
    outline: none;
    padding: 0 8px;
    text-decoration: none;
    transition-duration: 0.28s;
    transition-property: box-shadow, opacity;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    vertical-align: middle;
    white-space: nowrap;

    &.active {
      background-color: $accent-200;
      opacity: 1;
    }

    &.active:hover::before {
      background-color: $accent-200;
      opacity: 1;
      cursor: default;
    }

    &.active:hover {
      cursor: default;
    }

    &:hover {
      cursor: pointer;
    }

    &:hover::before {
      background-color: $accent-0;
      opacity: 1;
    }
  }
}
</style>
